// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2XzFP","choiceBoxes":"toolbarselects_choiceBoxes__JhNB5","simpleField":"toolbarselects_simpleField__15XgW"};